import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_USER_PROFILE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  UpdatePersonalUserProfilePayload,
  UpdatePersonalUserProfileResult,
} from '../types/updateUserProfile.types';

export const updatePersonalUserProfile = (builder: BuilderType) =>
  builder.mutation<UpdatePersonalUserProfileResult, UpdatePersonalUserProfilePayload>({
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_USER_PROFILE_URL,
    }),
    transformResponse: (response: GenericApiResponse<UpdatePersonalUserProfileResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
